export default __webpack_public_path__ + "static/media/filter_icon_pool_blue.88f1d457.svg";